function deobfuscateEmailLink(el) {
    let href = el.getAttribute("href");
    let updatedHref = href.replace("#MAIL:", "mailto:").replace("(at)", "@");
    el.href = updatedHref;
  }
  function deobfuscateEmailLinkText(el) {
    el.innerHTML = el.innerHTML.replace("(at)", "@");
  }
  export function deobfuscateEmails() {
    if (document.querySelector('a.obfuscated-link')) {
      var mailLink = document.querySelectorAll('a.obfuscated-link');
      mailLink.forEach((el) => deobfuscateEmailLink(el));
      var mailLinkText = document.querySelectorAll('span.obfuscated-link-text');
  mailLinkText.forEach((el) => deobfuscateEmailLinkText(el));
  }
  }